import type { Locale } from "./locale-utils";

// Перевод НАЗВАНИЙ преимуществ авто (чипы на карточке) с русского на английский
// для /en. Данные приходят из 1С (car_features_catalog.name) только по-русски —
// _en источника нет, поэтому маппинг захардкожен здесь. Ключи — name в нижнем
// регистре с обрезанными пробелами. Неизвестное имя возвращаем как есть.
const MAP: Record<string, string> = {
  // топливо / тип
  "гибрид": "Hybrid",
  "гибрид ⚡": "Hybrid ⚡",
  "hev": "HEV",
  "phev": "PHEV",
  "эко": "ECO",
  "грузовой": "Cargo",
  "кабриолет": "Convertible",
  // мультимедиа / оснащение
  "android auto, apple car play": "Android Auto, Apple CarPlay",
  "apple car play": "Apple CarPlay",
  "wi-fi роутер бесплатно": "Free Wi-Fi router",
  "камера 360": "360° camera",
  "камера заднего вида": "Rear-view camera",
  "кожаный салон": "Leather interior",
  "круиз контроль": "Cruise control",
  "навигация": "Navigation",
  "люк": "Sunroof",
  "панорамный люк": "Panoramic sunroof",
  "видеорегистратор бесплатно": "Free dashcam",
  "держатель для телефона бесплатно": "Free phone holder",
  // страхование / условия
  "все виды страхования": "All insurance types",
  "полная страховка": "Full insurance",
  "пробег без ограничений": "Unlimited mileage",
  "без депозита": "No deposit",
  "без залога": "No security deposit",
  "низкий депозит": "Low deposit",
  "без кредитной карты": "No credit card",
  "бесплатная отмена": "Free cancellation",
  "бронирование без предоплаты": "Booking without prepayment",
  "защита бронирования": "Booking protection",
  "моментальное бронирование": "Instant booking",
  "круглосуточная помощь на дороге": "24/7 roadside assistance",
  // подача / возврат
  "бесплатная подача": "Free delivery",
  "бесплатная подача в аэропорт (круглосуточно)": "Free airport delivery (24/7)",
  "бесплатная подача на поляну": "Free delivery to Polyana",
  "подача в аэропорт бесплатно": "Free airport delivery",
  "круглосуточная подача в аэропорт": "24/7 airport delivery",
  "круглосуточная подача в аэропорт бесплатно": "Free 24/7 airport delivery",
  "бесплатный возврат в геленджике": "Free return in Gelendzhik",
  // детское / доп. оборудование
  "детское кресло бесплатно": "Free child seat",
  "детское кресло, бустер бесплатно": "Free child seat & booster",
  "детское оборудование бесплатно": "Free child equipment",
  "бустер бесплатно": "Free booster seat",
  "крепления для лыж/ сноуборда бесплатно": "Free ski/snowboard rack",
  "электросамокат бесплатно": "Free e-scooter",
  // мойка
  "мойка": "Car wash",
  "мойка включена": "Car wash included",
  "акция! мойка включена": "Sale! Car wash included",
  // поездки
  "выезд в абхазию": "Trips to Abkhazia allowed",
  "выезд в карелию": "Trips to Karelia allowed",
  "выезд на острова": "Trips to the islands allowed",
  "крымский мост - бесплатно от 3х дней аренды": "Crimean Bridge — free from 3 rental days",
  // привод
  "полный привод": "AWD",
  // маркетинговые бейджи
  "новое авто": "New car",
  "новый автомобиль": "New car",
  "новый автомобиль!": "New car!",
  "авто с гарантией модели": "Guaranteed model",
  "популярная модель": "Popular model",
  "рекомендуем": "Recommended",
  "выгодное предложение!": "Great deal!",
  "акция!": "Sale!",
  "акция": "Sale",
  "хит": "Bestseller",
  "промо": "Promo",
  "promo": "PROMO",
  "промо ": "Promo",
};

export function featureLabelEn(name: string | undefined, locale: Locale, nameEn?: string): string {
  const v = (name || "").trim();
  if (!v || locale !== "en") return v;
  const mapped = MAP[v.toLowerCase()];
  if (mapped) return mapped;
  // «6 Мест» / «6+1 мест» / «7 мест» → «6 seats» / «6+1 seats»
  const seats = v.match(/^(\d+(?:\+\d+)?)\s*мест[оа]?$/i);
  if (seats) return `${seats[1]} seats`;
  // «2024 год» → «2024»
  const year = v.match(/^(\d{4})\s*год$/i);
  if (year) return year[1];
  // Единый источник: name_en из каталога (авто-перевод при синке). Курируемый
  // MAP выше приоритетнее (качество), а name_en закрывает всё остальное, чтобы
  // на /en не оставалось русских названий.
  const en = (nameEn || "").trim();
  if (en) return en;
  return v;
}
